compiler('[preview-auto-import-start-date]', (element) => {
  const targetUrl = element.getAttribute('preview-auto-import-start-date');
  const inputs = element.querySelectorAll('input, select');
  const csrfToken = document.head.querySelector('meta[name="csrf-token"][content]').content;

  async function updateMessage() {
    var targetDiv = document.querySelector('#auto-import-start-date-message');
    var formData = new FormData(inputs[0].form);

    const response = await fetch(targetUrl, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-CSRF-Token': csrfToken
      },
    })
    if (response.ok) {
      const html = await response.text();
      targetDiv.innerHTML = sanitizeHtml(html, {
        allowedAttributes: {
          '*': ['class']
        }
      })
    }
  }

  inputs.forEach(element => element.addEventListener('change', updateMessage))
})
